<template>
  <div class="top-menu">
    <div class="container">
      <div class="row">
        <div class="col-lg-9">
          <div class="bg-light-grey">
            <nav class="menu-left">
              <ul>
                <li v-if="isFeedSupportedForLang($i18n.locale)">
                  <localized-link :to="{name: 'Experts'}"
                                  :data-text="$t('menu.stories')"
                                  :class="{'active': activeRoute === 'Experts'}">
                    <span>{{$t('menu.stories')}}</span>
                  </localized-link>
                </li>
                <li>
                  <localized-link :to="{name: 'Home'}"
                                  :data-text="$t('menu.productSupport')"
                                  :class="{'active': activeRoute != 'Experts' && activeRoute != 'About'}">
                    <span>{{$t('menu.productSupport')}}</span>
                  </localized-link>
                </li>
                <li class="dropdown">
                  <button :data-text="$t('menu.training')">
                    <span>{{$t('menu.training')}}</span>
                  </button>
                  <ul class="submenu">
                    <li>
                      <a href="https://showroom.nissens.com/ntc/" target="_blank">
                        <span>{{$t('menu.concept')}}</span>
                      </a>
                    </li>
                    <li v-if="learningPath">
                      <localized-link :to="`/search/${learningPath}`">
                        <span>{{$t('menu.eLearningModules')}}</span>
                      </localized-link>
                    </li>
                  </ul>
                </li>
                <li class="dropdown">
                  <button :data-text="$t('menu.tools')">
                    <span>{{$t('menu.tools')}}</span>
                  </button>
                  <ul class="submenu">
                    <li>
                      <localized-link :to="{name: 'Oil Gas Finder'}">
                        <span>{{$t('menu.oilGasFinder')}}</span>
                      </localized-link>
                    </li>
                  </ul>
                </li>
                <li>
                  <localized-link :to="{name: 'About'}"
                                  :data-text="$t('menu.about')"
                                  :class="{'active': activeRoute === 'About'}">
                    <span>{{$t('menu.about')}}</span>
                  </localized-link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="bg-primary">
            <nav class="menu-right">
              <ul>
                <li>
                  <div v-if="loggedIn && user" class="d-flex align-items-center">
                    <localized-link :to="{name: 'Profile'}">
                      <div class="d-flex align-items-center">
                        <b-icon icon="person-fill" class="mr-2"></b-icon>
                        <span class="user-name">{{user.display_name}}</span>
                      </div>
                    </localized-link>
                  </div>
                  <localized-link v-else :to="{name: 'Login'}">
                    <span>{{$t('menu.login')}}</span>
                  </localized-link>
                </li>
                <li class="d-flex align-items-center">
                  <div v-if="loggedIn && user">
                    <button @click="logout()" v-b-tooltip.hover :title="$t('auth.logout')" class="button-logout">
                      <b-icon icon="box-arrow-right" class="text-secondary text-md"></b-icon>
                    </button>
                  </div>
                  <div v-else>
                    <localized-link :to="{name: 'Signup'}">
                      <span>{{$t('auth.signup')}}</span>
                    </localized-link>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeRoute: String,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.user.status.loggedIn;
    },
    user() {
      return this.$store.state.user.user;
    },
    learningPath() {
      switch (this.$i18n.locale) {
        case 'en':
          return 'learning';
        case 'cz':
          return 'samovzdělávací kurz';
        case 'da':
          return 'Selvlærende kursus';
        case 'de':
          return 'Selbstlernkurs';
        case 'es':
          return 'AUTOAPRENDIZAJE';
        case 'fi':
          return 'Itseopiskelukurssi';
        case 'fr':
          return "cours d'auto";
        case 'nl':
          return 'ZELFSTUDIECURSUS';
        case 'pl':
          return 'kurs online';
        case 'ru':
          return 'Курс самообучения';
        case 'se':
          return 'Självlärande kurs';
        case 'ua':
          return 'Курс самонавчання';
        default:
          return '';
      }
    },
  },
  watch: {
    $route: {
      // eslint-disable-next-line
      handler: function (route) {
        this.activeRoute = route.name;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('user/LOGOUT');
      if (this.$route.name === 'Profile') {
        this.$router.push(`/${this.$i18n.locale}/`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.top-menu {
  padding-top: 120px;
  padding-bottom: 30px;
  @include media-breakpoint-down(sm) {
    padding-top: 90px;
  }
  nav.menu-left,
  nav.menu-right {
    position: relative;
    ul {
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      padding-left: 0;
      margin-bottom: 0;
      li {
        a, button {
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          padding: .5rem 1.5rem;
          transition: background-color .2s ease-in-out;
          margin-right: 1px;
          text-transform: uppercase;
          color: $primary;
          width: max-content;
          @extend .text-sm;
          &.disabled {
            color: #b9b9b9;
            &:hover {
              font-weight: inherit;
              cursor: default;
            }
          }
          &:hover {
            font-weight: bold;
          }
          &::after {
            content: attr(data-text);
            content: attr(data-text) / "";
            height: 0;
            visibility: hidden;
            overflow: hidden;
            user-select: none;
            pointer-events: none;
            font-weight: bold;
            @media speech {
              display: none;
            }
          }
          span {
            @extend .font-italic-custom;
          }
        }
        button {
          background-color: transparent;
          border: 0;
        }
      }
      @include media-breakpoint-down(lg) {
        li:last-child {
          margin-left: unset!important;
        }
      }
    }
  }
  nav.menu-left {
    &::before {
      content: '';
      position: absolute;
      left: -50vw;
      height: 100%;
      width: 50vw;
      background-color: $light-grey;
    }
    ul {
      li {
        &:hover > a,
        &:hover > button,
        a.active,
        button.active {
          background-color: $primary;
          color: white;
          font-weight: bold;
        }
        &:last-child {
          margin-left: auto;
        }
      }
    }
  }
  nav.menu-right {
    &::before {
      content: '';
      position: absolute;
      right: calc(-50vw + 1px);
      height: 100%;
      width: 50vw;
      background-color: $primary;
      overflow: hidden;
    }
    ul {
      justify-content: space-between;
      li {
        a, button {
          color: $secondary;
        }
      }
    }
  }
}
.dropdown {
  position: relative;
  > ul.submenu {
    display: none!important;
    position: absolute;
    width: calc( 100% - 1px );
    background-color: $light-grey;
    z-index: 99;
    &:hover + button {
      background: $primary;
    }
    li {
      width: 100%;
      a, button {
        width: 100%!important;
        font-size: 13px!important;
        align-items: flex-start!important;
        padding: 0.5rem .8rem!important;
        line-height: 1rem;
        &:hover {
          font-weight: 300!important;
        }
        span {
          transform: unset!important;
        }
      }
    }
  }
  &:hover {
    > .submenu {
      display: block!important;
    }
  }
}
span.user-name {
  white-space: nowrap;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
}
button.button-logout {
  padding-right: 0!important;
  padding-left: 0!important;
}
</style>
